module.exports = __webpack_public_path__ + "static/media/Icon-arrow-white-reversed.e1d986e1.png";